import { EmployeeBase } from './base/employee-base';

export class Employee extends EmployeeBase { }